import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import Icons from './Icons'

const trustBadges = [
  { icon: Icons.Shield, label: 'SOC 2认证' },
  { icon: Icons.Lock, label: 'SSL加密传输' },
  { icon: Icons.Security, label: '冷钱包存储' },
  { icon: Icons.Globe, label: '全球合规' },
  { icon: Icons.Users, label: '5000万用户信赖' },
]

export function HighlightStrip() {
  const stripRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.trust-badge',
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.1,
          scrollTrigger: {
            trigger: stripRef.current,
            start: 'top 80%',
          },
        }
      )
    }, stripRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={stripRef}
      id="security"
      className="section-padding relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-[#13131a]" />
      <div className="absolute inset-0 grid-pattern opacity-20" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">安全合规认证</span>
          </h2>
          <p className="text-[#8080a0] text-lg max-w-2xl mx-auto">
            okb官网通过国际权威安全认证，为用户提供银行级资产安全保障
          </p>
        </div>

        {/* Trust Badges Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {trustBadges.map((badge, index) => (
            <div
              key={index}
              className="trust-badge cyber-card flex flex-col items-center text-center group cursor-pointer"
            >
              <div className="mb-4 text-[#ff00ff] group-hover:text-[#00ffff] transition-colors">
                <badge.icon />
              </div>
              <span className="text-[#e0e0ff] font-medium">{badge.label}</span>
            </div>
          ))}
        </div>

        {/* Security Features */}
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="cyber-card">
            <div className="w-12 h-12 rounded-xl bg-[rgba(255,0,255,0.1)] flex items-center justify-center mb-4">
              <Icons.Lock />
            </div>
            <h3 className="text-xl font-semibold text-[#e0e0ff] mb-2">冷热钱包分离</h3>
            <p className="text-[#8080a0]">98%资产存储于离线冷钱包，物理隔离网络攻击风险</p>
          </div>
          <div className="cyber-card">
            <div className="w-12 h-12 rounded-xl bg-[rgba(0,255,255,0.1)] flex items-center justify-center mb-4">
              <Icons.Security />
            </div>
            <h3 className="text-xl font-semibold text-[#e0e0ff] mb-2">多重签名保护</h3>
            <p className="text-[#8080a0]">采用多重签名技术，确保每一笔交易都经过严格验证</p>
          </div>
          <div className="cyber-card">
            <div className="w-12 h-12 rounded-xl bg-[rgba(255,0,255,0.1)] flex items-center justify-center mb-4">
              <Icons.Shield />
            </div>
            <h3 className="text-xl font-semibold text-[#e0e0ff] mb-2">实时风控系统</h3>
            <p className="text-[#8080a0]">AI驱动的实时监控系统，7x24小时守护账户安全</p>
          </div>
        </div>
      </div>
    </section>
  )
}
